import React, { FunctionComponent, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { ContainerTable } from '../../components/layout/main/mainStyles';
import { useGetReleaseVersionsMutation } from '../../services/application/applicationService';

interface CodeVersionProps {}

const CodeVersion: FunctionComponent<CodeVersionProps> = () => {
  const [getReleaseVersions, { data, isLoading }] =
    useGetReleaseVersionsMutation();

  useEffect(() => {
    getReleaseVersions({});
  }, []);
  return (
    <ContainerTable component="main">
      <DataTable
        className="mt-3"
        rowHover
        value={data || []}
        size="small"
        scrollable
        scrollHeight="flex"
        paginator={data && data.length >= 20}
        selectionPageOnly
        rows={20}
        rowsPerPageOptions={[5, 10, 20, data ? data.length : 50]}
        tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
      >
        <Column
          field="updatedAt"
          sortable
          header="Update At"
          body={(rowData) =>
            moment(rowData.creationDate).format('DD/MM/YYYY HH:mm')
          }
        />
        <Column field="project" header="Project" sortable frozen />

        <Column field="version" header="Version" sortable />
      </DataTable>
    </ContainerTable>
  );
};

export default CodeVersion;
